import './contribution_bar.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '../text/text';

interface Props {
  percentage: number;
  label: string;
  value?: string;
  color: string;
  href?: string;
}

export function ContributionBar({ percentage, label, value, color, href }: Props): JSX.Element {
  const Label = href ? Link : 'p';

  return (
    <div className="contribution-bar">
      <Label to={href || '#'} className="contribution-bar__label-link">
        {label}
      </Label>

      {value && (
        <div className="contribution-bar__value">
          <Text type="contribution-bar-value">
            <p>{value}</p>
          </Text>
        </div>
      )}
      <div
        className="contribution-bar__bar"
        style={{ '--progress-bar-width': percentage + '%', '--progress-bar-color': color } as React.CSSProperties}
      />
    </div>
  );
}
